import { Tool } from './Tool';

export class TextTool extends Tool {
  public title = 'TOOLBAR_TEXT';

  public icon = 'icon-text1';
}

export const textTool = new TextTool();
